<!-- Mobile backdrop -->
<div
  class="filter-backdrop"
  *ngIf="isMobileOpen"
  (click)="closeMobile()"
></div>

<aside class="filter-sidebar" [class.mobile-open]="isMobileOpen">
  <!-- Header -->
  <div class="filter-header">
    <div class="filter-title-wrap">
      <h3 class="filter-title">Filtreler</h3>
      <span class="filter-count-badge" *ngIf="totalSelectedCount > 0">
        {{ totalSelectedCount }}
      </span>
    </div>
    <button
      type="button"
      class="filter-close-mobile"
      (click)="closeMobile()"
      aria-label="Kapat"
    >
      ✕
    </button>
  </div>

  <div class="filter-summary" *ngIf="totalCount > 0">
    {{ totalCount }} otel
  </div>

  <!-- Loading — Skeleton -->
  <div *ngIf="loading" class="filter-skeleton">
    <!-- Fiyat aralığı skeleton -->
    <div class="sk-section">
      <div class="sk-bar sk-label"></div>
      <div class="sk-row">
        <div class="sk-bar sk-input"></div>
        <div class="sk-bar sk-input"></div>
      </div>
    </div>

    <!-- Filtre grupları skeleton (5 grup) -->
    <div class="sk-section" *ngFor="let i of [1,2,3,4,5]">
      <div class="sk-group-header">
        <div class="sk-bar sk-title"></div>
        <div class="sk-bar sk-chevron"></div>
      </div>
      <div class="sk-checkbox-list" *ngIf="i <= 3">
        <div class="sk-checkbox" *ngFor="let j of [1,2,3,4]">
          <div class="sk-box"></div>
          <div class="sk-bar sk-text" [style.width.%]="40 + (j * 15)"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="filter-content" *ngIf="!loading">

    <!-- Sıralama -->
    <section class="filter-section">
      <label class="filter-label">Sıralama</label>
      <div class="sort-options">
        <button
          type="button"
          class="sort-chip"
          *ngFor="let opt of sortOptions"
          [class.sort-chip-active]="orderBy === opt.value"
          (click)="onSortChange(opt.value)"
        >
          {{ opt.label }}
        </button>
      </div>
    </section>

    <!-- Fiyat aralığı -->
    <section class="filter-section">
      <label class="filter-label">Fiyat Aralığı (TL)</label>
      <div class="price-range">
        <input
          type="number"
          class="filter-input"
          placeholder="Min"
          [(ngModel)]="minPrice"
          min="0"
        />
        <span class="price-range-sep">–</span>
        <input
          type="number"
          class="filter-input"
          placeholder="Max"
          [(ngModel)]="maxPrice"
          min="0"
        />
      </div>
    </section>

    <!-- Dinamik gruplar -->
    <section
      class="filter-section filter-group"
      *ngFor="let group of groups; trackBy: trackByKey"
    >
      <button
        type="button"
        class="group-header"
        (click)="toggleGroup(group)"
        [attr.aria-expanded]="group.expanded"
      >
        <span class="group-title">
          {{ group.title }}
          <span class="group-selected" *ngIf="selectedCount(group) > 0">
            ({{ selectedCount(group) }})
          </span>
        </span>
        <span class="group-chevron" [class.open]="group.expanded">▾</span>
      </button>

      <div class="group-body" *ngIf="group.expanded">
        <input
          *ngIf="group.items.length > 8"
          type="text"
          class="filter-input filter-input-sm"
          placeholder="Ara..."
          [(ngModel)]="group.searchTerm"
        />

        <ul class="checkbox-list">
          <li
            *ngFor="let item of filteredItems(group); trackBy: trackByCode"
            class="checkbox-item"
          >
            <label class="checkbox-label">
              <input
                type="checkbox"
                [checked]="isChecked(group, item)"
                (change)="toggleItem(group, item, $any($event.target).checked)"
              />
              <span class="checkbox-text">{{ item.name }}</span>
              <span class="checkbox-hotel-count" *ngIf="item.hotelIds?.length">
                ({{ item.hotelIds!.length }})
              </span>
            </label>
          </li>
          <li *ngIf="filteredItems(group).length === 0" class="no-result">
            Eşleşen seçenek yok
          </li>
        </ul>
      </div>
    </section>

    <div class="filter-empty" *ngIf="groups.length === 0 && !isDatelessSearch">
      Bu arama için filtre bulunamadı.
    </div>

    <div class="filter-dateless-hint" *ngIf="isDatelessSearch">
      <span class="hint-icon">📅</span>
      <p class="hint-title">Filtreler tarih gerektirir</p>
      <p class="hint-text">
        Tüm filtre seçeneklerini görmek için yukarıdan <strong>giriş ve çıkış tarihi</strong> seçip tekrar arayın.
      </p>
    </div>
  </div>

  <!-- Footer (sticky) -->
  <div class="filter-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="clearAll()"
    >
      Temizle
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="apply()"
    >
      Uygula
    </button>
  </div>
</aside>
